import React from "react";
import { api } from "@/lib/api";

const Ctx = React.createContext({ filesBySlot: {}, custom: [], loading: true, refresh: () => {} });

export const useResourceFiles = () => React.useContext(Ctx);

export const ResourceFilesProvider = ({ children }) => {
  const [filesBySlot, setFilesBySlot] = React.useState({});
  const [custom, setCustom] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const refresh = React.useCallback(async () => {
    try {
      const [slots, extra] = await Promise.all([api.get("/resources"), api.get("/custom-resources")]);
      setFilesBySlot(Object.fromEntries(slots.data.map((f) => [f.slotKey, f])));
      setCustom(extra.data);
    } catch (e) {
      setFilesBySlot({});
      setCustom([]);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    refresh();
  }, [refresh]);

  return <Ctx.Provider value={{ filesBySlot, custom, loading, refresh }}>{children}</Ctx.Provider>;
};
